import { NgModule, APP_INITIALIZER }           from '@angular/core';
import { CommonModule }       from '@angular/common';
import { FormsModule }        from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';
import { TranslateModule } from '@ngx-translate/core';

import { FacturaCercadorComponent } from './factures-cercador.component';
import { FacturesListComponent } from './factures-list/factures-list.component';
import { FacturesFiltersComponent } from './factures-filtre/factures-filtre.component';

import { FListService } from './services/factures-list.service';
import { FacturaService } from '../services/factures-service/factures.service';
import { InvoicesResumeComponent } from './invoices.resume/invoices.resume.component';
 
import { AngularMaterialModule } from '../angular-material.module';

export function appInitializerFactory(translate: TranslateService, languageService: LanguageService) {
  return () => languageService.initAndWait();
}

@NgModule({
  imports:      [
    CommonModule,
    FormsModule,
    AngularMaterialModule,
    TranslateModule
  ],
  declarations: [
    FacturaCercadorComponent,
    FacturesListComponent,
    FacturesFiltersComponent,
    InvoicesResumeComponent
  ],
  exports:      [
    FacturaCercadorComponent
  ],
  providers:    [ 
    FListService, FacturaService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, LanguageService],
      multi: true
    }
]
})
export class FacturesSearchModule { }
